import classNames from "classnames";
import { addHours, format } from "date-fns";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Menu } from "primereact/menu";
import { useEffect, useRef, useState } from "react";
import { BiWallet } from "react-icons/bi";
import { FaHistory, FaInfoCircle, FaPhone, FaSearch, FaTimes } from "react-icons/fa";
import { FaChartLine, FaDollarSign, FaFileExcel } from "react-icons/fa6";
import { FiFile } from "react-icons/fi";
import { GiCog } from "react-icons/gi";
import { IoBriefcase } from "react-icons/io5";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import AppCard from "../../../../components/appCard";
import { AddPayment } from "../../../../components/dashboard/inadimplencias/listagem/adicionarPagamento";
import { CancelNegotiation } from "../../../../components/dashboard/inadimplencias/listagem/cancelarNegociacao";
import { CommunicationInfo } from "../../../../components/dashboard/inadimplencias/listagem/comunicacaoInfo";
import { NegotiationDetail } from "../../../../components/dashboard/inadimplencias/listagem/detalhes";
import { ExportarCobrancas } from "../../../../components/dashboard/inadimplencias/listagem/exportar";
import { InaCobranca } from "../../../../components/dashboard/inadimplencias/listagem/inativaCobranca";
import { PersonalCobranca } from "../../../../components/dashboard/inadimplencias/listagem/personalCobranca";
import { PersonalInfo } from "../../../../components/dashboard/inadimplencias/listagem/personalInfo";
import { ProtestInfo } from "../../../../components/dashboard/inadimplencias/listagem/protestoInfo";
import { Simulation } from "../../../../components/dashboard/inadimplencias/listagem/simulacao";
import { useInfo } from "../../../../context/infoContext";
import { Api, ApiAdimplencia } from "../../../../services/api";
import { LargeTablePague, MenuPague } from "../../../../styles/primeReactConfig";
import formatDocument from "../../../../utils/formatCurrency";

export const ListagemCobrancas = () => {

  const menu = useRef(null);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [mobile, setMobile] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [first, setFirst] = useState(0);
  const [negotiationData, setNegotiationData] = useState([]);
  const [totalNegotiation, setTotalNegotiation] = useState(0);
  const [filterParam, setFilterParam] = useState("");
  const [searchState, setSearchState] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showCancelNegotiation, setShowCancelNegotiation] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [showCommunicationInfo, setShowCommunicationInfo] = useState(false);
  const [showSimulation, setShowSimulation] = useState(false);
  const [showPersonalInfo, setShowPersonalInfo] = useState(false);
  const [showPersonalCobranca, setShowPersonalCobranca] = useState(false);
  const [showProtestoInfo, setShowProtestoInfo] = useState(false);
  const [showInativaCobranca, setShowInativaCobranca] = useState(false);
  const [showListaRelatorio, setShowListaRelatorio] = useState(false);
  const [rowCurrent, setRowCurrent] = useState([]);
  const [listaParceiros, setListaParceiros] = useState([]);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [rowsPerPageOptions] = useState([10, 20, 50]);
  const { gestorData } = useInfo();

  const getActionOptions = (rowData) => [
    {
      label: "Adicionar Pagamento",
      icon: <FaDollarSign className="mr-2" />,
      value: "AP",
      command: () => {
        setShowAddPayment(true);
      },
      disabled:
        rowData.cobranca_tipo_pagamento === "Em Aberto" ||
          rowData.cobranca_tipo_pagamento === "Em aberto" ||
          rowData.cobranca_tipo_pagamento === "Enviado a Protesto" ||
          rowData.cobranca_tipo_pagamento === "Em Processamento" ||
          rowData.cobranca_tipo_pagamento === "Em Processamento (Parcial)" ||
          rowData.cobranca_tipo_pagamento === "Pago (Cliente)" ||
          rowData.cobranca_tipo_pagamento === ""
          ? false
          : true,
    },

    {
      label: "Detalhes",
      icon: <FaChartLine className="mr-2" />,
      value: "DT",
      command: () => {
        setShowDetail(true);
      },
      disabled:
        rowData.cobranca_tipo_pagamento === "Em Processamento" ||
          rowData.cobranca_tipo_pagamento === "Em Processamento (Parcial)" ||
          rowData.cobranca_tipo_pagamento === "Pago" ||
          rowData.cobranca_tipo_pagamento === "Pago (Cliente)" ||
          rowData.cobranca_tipo_pagamento === "Pago durante o Protesto" ||
          rowData.cobranca_tipo_pagamento === "Acordo Não Pago" ||
          rowData.cobranca_tipo_pagamento === "Enviado a Protesto" ||
          rowData.cobranca_tipo_pagamento === ""
          ? false
          : true,
    },

    {
      label: 'Protesto',
      icon: <IoBriefcase className="mr-2" />,
      value: 'PT',
      command: () => {
        setShowProtestoInfo(true)
      },
      disabled:
        (
          rowData.cobranca_tipo_pagamento === "Pago" || rowData.cobranca_tipo_pagamento === "Acordo Não Pago" ||
          rowData.cobranca_tipo_pagamento === "Pago (Cliente)" || rowData.cobranca_tipo_pagamento === "Enviado a Protesto" ||
          rowData.cobranca_tipo_pagamento === "Em Processamento" || rowData.cobranca_tipo_pagamento === "Em Processamento (Parcial)" ||
          (rowData.cobranca_tipo_pagamento === "Inativado" && rowData.protesto_status === 'ENVIADO') || rowData.cobranca_tipo_pagamento === ""
        )
          ? false
          : true,
    },
    {
      label: "Simulação",
      icon: <FiFile className="mr-2" />,
      value: "SM",
      command: () => {
        setShowSimulation(true);
      },
      disabled:
        rowData.cobranca_tipo_pagamento === "Em Aberto" ||
          rowData.cobranca_tipo_pagamento === "Em aberto" ||
          rowData.cobranca_tipo_pagamento === ""
          ? false
          : true,
    },

    {
      label: "Info Devedor",
      icon: <FaInfoCircle className="mr-2" />,
      value: "ID",
      command: () => {
        setShowPersonalInfo(true);
      },
    },

    {
      label: "Info Cobrança",
      icon: <BiWallet className="mr-2" />,
      value: "IC",
      command: () => {
        setShowPersonalCobranca(true);
      },
      disabled:
        rowData.cobranca_tipo_pagamento === "Em Aberto" ||
          rowData.cobranca_tipo_pagamento === "Em aberto" ||
          rowData.cobranca_tipo_pagamento === ""
          ? false
          : true,
    },
    {
      label: "Info Comunicação",
      icon: <FaPhone className="mr-2" />,
      value: "ID",
      command: () => {
        setShowCommunicationInfo(true);
      },
    },
  ];

  const getCancelaOptions = (rowData) => [
    {
      label: "Cancelar Negociação",
      icon: <FaTimes className="mr-2" />,
      value: "DS",
      command: () => {
        setShowCancelNegotiation(true);
      },
      disabled: rowData.cobranca_tipo_pagamento !== "Em Processamento" &&
        rowData.cobranca_tipo_pagamento !== "Em Processamento (Parcial)",
    },
  ];

  const [filterOptions, setFilterOptions] = useState([
    { label: "Todos", value: "all" },
    { label: "Documento", value: "documento" },
    { label: "Nome", value: "nome" },
    { label: "Código do Cliente", value: "codigocliente" },
    { label: "Em Aberto", value: "aberto" },
    { label: "Enviado a protesto", value: "enviado" },
    { label: "Pago", value: "pago" },
    { label: "Pago no Cartorio", value: "pagoCartorio" },
    { label: "Pago (Cliente)", value: "pagocliente" },
    { label: "Em Processamento", value: "processamento" },
    { label: "Acordo não Pago", value: "cobrancaquebrada" },
    { label: "Inativado", value: "inativa" },
  ]);

  useEffect(() => {
    if (searchState) Search(page, rows);
    else getAll(page, rows);
  }, [reload]);
  useEffect(() => {
    window.addEventListener("resize", ScreenCheck);
    ScreenCheck();
  }, []);

  useEffect(() => {
    if (gestorData.gestor_id) {
      setFilterOptions((prevFilters) => {
        const exists = prevFilters.filter((item) => item.value === "parceiros")[0];
        if (exists) return prevFilters;
        else return [...prevFilters, { label: "Parceiros", value: "parceiros" }];
      });
      carregaParceiros(gestorData.usuario_id);
    }
  }, [gestorData]);

  const carregaParceiros = async (usuarioId) => {
    try {
      const { data } = await ApiAdimplencia.get(`/credor/listarTodos/${usuarioId}`);

      setListaParceiros(
        data.map((item) => {
          return { label: item.credor_nome, value: item.credor_id };
        })
      );
    } catch (error) {
      console.log(error.response);
      toast.error("Houve um erro ao carregar parceiros do gestor.");
    }
  };

  const getAll = async (e, rows) => {
    setLoading(true);
    try {
      const { data } = await Api.get(`cobranca/consulta-cobrancas/${rows}/${e}/all/null`);
      setNegotiationData(data.DateResult);
      setTotalNegotiation(Number(data.count));
    } catch (error) {
      console.log(error.response);
      toastController("error", "Erro de conexão com o servidor, tente novamente mais tarde");
    } finally {
      setLoading(false);
    }
  };
  const Search = async (e = 0, rows = 10) => {
    setLoading(true);
    try {
      if (selectedFilter === "parceiros") {
        const { data } = await ApiAdimplencia.get(`/gestorCobranca/buscar/${filterParam}/${rows}/${e}`);
        setNegotiationData(data.results);
        setTotalNegotiation(data.count);
      }
      if (selectedFilter === "codigocliente") {
        const { data } = await Api.get(`cobranca/consulta-cobrancas/${rows}/${e}/${selectedFilter}/${filterParam ? filterParam : null}`);
        setNegotiationData(data.DateResult);
        setTotalNegotiation(data.count);
      }       
      if (selectedFilter === "nome") {
        const { data } = await Api.get(`cobranca/consulta-cobrancas/${rows}/${e}/${selectedFilter}/${filterParam ? filterParam : null}`);
        setNegotiationData(data.DateResult);
        setTotalNegotiation(data.count);
      } else {
        const { data } = await Api.get(`cobranca/consulta-cobrancas/${rows}/${e}/${selectedFilter}/${filterParam ? unMask(filterParam) : null}`);
        setNegotiationData(data.DateResult);
        setTotalNegotiation(data.count);
      }
    } catch (err) {
      console.log(err);
      toast.error("Cliente não encontrado!");
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setLoadingCSV(true);
    try {
      await Api.post('relatorio/gerarRelatorioCobrancas', {
        tipo: selectedFilter,
        filtro: filterParam ? unMask(filterParam) : null
      })
      toastController('success', 'Relatório em processamento, pode demorar alguns minutos. Visualize no botão amarelo ao lado esquerdo - Histórico de Exportação.')
    } catch (error) {
      toastController('error', 'Erro de conexão com o sistema')
      console.log(error.response)
    }
    finally {
      setLoadingCSV(false);
    }
  }

  function handleSelectAction(rowData) {
    setRowCurrent(rowData);
  }

  function handleSelection(e) {
    if (!menu.current) {
    } else menu.current.toggle(e);
  }

  function toastController(type, message) {
    return toast(message, { type: type });
  }

  function handleSearch(e) {
    if (e === 13) {
      if (selectedFilter === "document" && (filterParam.length === 14 || filterParam.length === 18)) {
        setSearchState(true);
        return Search();
      }
      if (selectedFilter === "aberto" || "enviado" || "pago" || "pagocliente" || "processamento") {
        setSearchState(true);
        return Search();
      }
      if (selectedFilter !== "document") return Search();
    }
  }

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setRows(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    if (searchState) return Search(event.page, event.rows);
    setReload((prevReload) => !prevReload);
  }

  const formatCurrency = (value) => {
    return Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const negotiationTableHeader = (
    <div className="w-full flex flex-wrap ">
      <h4 className="w-full text-2xl mb-1">
        <b>Lista de Inadimplências</b>
      </h4>
      <div className="w-full flex md:flex-row flex-col justify-between gap-2">
        <div className="w-full flex gap-5">
          <Button
            iconPos="left"
            icon={<FaHistory className="text-2xl" />}
            tooltip="Histórico de Exportações"
            onClick={() => setShowListaRelatorio(true)}
            pt={{
              root: `hover:dark:bg-amber-300 hover:bg-yellow-600 
              dark:bg-amber-500 bg-yellow-500 p-3 rounded-md
              text-white dark:text-black transition duration-300`,
              label: "absolute",
            }}
          />
          <Button
            type="button"
            icon={<FaFileExcel className="text-2xl" />}
            onClick={() => handleExport()}
            pt={{
              root: `hover:dark:bg-green-500 hover:bg-green-600 
              dark:bg-green-400 bg-green-500 p-3 rounded-md
              text-white dark:text-black transition duration-300
              w-[3rem] h-[3rem]`,
              label: "absolute",
            }}
            tooltip="Exportar em CSV"
            loading={loadingCSV}
          />
        </div>
        <div className="w-full flex flex-row justify-end">
          <Dropdown
            value={selectedFilter}
            options={filterOptions}
            onChange={(e) => {
              setSelectedFilter(e.value);
              setFilterParam(null);
            }}
            pt={{
              root: ({ props }) => ({
                className: classNames(
                  'cursor-pointer inline-flex relative select-none h-12',
                  'bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-l-md',
                  'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300',
                  'w-full md:w-56',
                  'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
                  { 'opacity-60 select-none pointer-events-none cursor-default': props.disabled }
                )
              }),
              itemLabel: 'font-semibold',
              item: ({ context }) => ({
                className: classNames(
                  'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
                  'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
                  'dark:text-white/80 dark:hover:bg-gray-700 dark:hover:text-white',
                  'hover:text-gray-900 hover:bg-gray-200 hover:font-bold',
                  {
                    'text-gray-700': !context.focused && !context.selected,
                    'bg-gray-300 text-gray-700 dark:text-white/80 dark:bg-gray-800/90': context.focused && !context.selected,
                    'bg-blue-100 text-blue-700 dark:bg-sky-800 dark:text-white/80': context.focused && context.selected,
                    'bg-blue-50 text-blue-700 dark:bg-sky-700 dark:text-white/80': !context.focused && context.selected,
                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled
                  }
                )
              }),
              // select: 'rounded-full'
            }}
          />


          {selectedFilter === "documento" &&
            <InputText
              pt={{
                root: ({ props, context }) => ({
                  className: classNames(
                    'm-0 w-full md:w-auto',
                    'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                    {
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                        !context.disabled,
                      'hover:border-blue-500': !props.invalid && !context.disabled,
                      'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                      'border-gray-300 dark:border-blue-900/40': !props.invalid,
                      'border-red-500 hover:border-red-500/80 focus:border-red-500':
                        props.invalid && !context.disabled,
                      'border-red-500/50': props.invalid && context.disabled,
                    },
                    {
                      'text-lg px-4 py-4': props.size === 'large',
                      'text-xs px-2 py-2': props.size === 'small',
                      'p-3 text-base': !props.size || typeof props.size === 'number'
                    },
                    {
                      'pl-8': context.iconPosition === 'left',
                      'pr-8': props.iconPosition === 'right'
                    }
                  ),
                }),
              }}
              value={filterParam}
              onChange={(e) => setFilterParam(mask(unMask(e.target.value), ["999.999.999-99", "99.999.999/9999-99"]))}
              placeholder="Busca por CPF/CNPJ"
              onKeyDown={(e) => handleSearch(e.keyCode)}
            />}
          {selectedFilter === "codigocliente" &&
            <InputText
              pt={{
                root: ({ props, context }) => ({
                  className: classNames(
                    'm-0 w-full md:w-auto',
                    'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                    {
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                        !context.disabled,
                      'hover:border-blue-500': !props.invalid && !context.disabled,
                      'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                      'border-gray-300 dark:border-blue-900/40': !props.invalid,
                      'border-red-500 hover:border-red-500/80 focus:border-red-500':
                        props.invalid && !context.disabled,
                      'border-red-500/50': props.invalid && context.disabled,
                    },
                    {
                      'text-lg px-4 py-4': props.size === 'large',
                      'text-xs px-2 py-2': props.size === 'small',
                      'p-3 text-base': !props.size || typeof props.size === 'number'
                    },
                    {
                      'pl-8': context.iconPosition === 'left',
                      'pr-8': props.iconPosition === 'right'
                    }
                  ),
                }),
              }}
              value={filterParam}
              onChange={(e) => setFilterParam(e.target.value)}
              placeholder="Busca por Código do Cliente"
              onKeyDown={(e) => handleSearch(e.keyCode)}
            />}
          {selectedFilter === "nome" &&
            <InputText
              pt={{
                root: ({ props, context }) => ({
                  className: classNames(
                    'm-0 w-full md:w-auto',
                    'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                    {
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                        !context.disabled,
                      'hover:border-blue-500': !props.invalid && !context.disabled,
                      'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                      'border-gray-300 dark:border-blue-900/40': !props.invalid,
                      'border-red-500 hover:border-red-500/80 focus:border-red-500':
                        props.invalid && !context.disabled,
                      'border-red-500/50': props.invalid && context.disabled,
                    },
                    {
                      'text-lg px-4 py-4': props.size === 'large',
                      'text-xs px-2 py-2': props.size === 'small',
                      'p-3 text-base': !props.size || typeof props.size === 'number'
                    },
                    {
                      'pl-8': context.iconPosition === 'left',
                      'pr-8': props.iconPosition === 'right'
                    }
                  ),
                }),
              }}
              value={filterParam}
              onChange={(e) => setFilterParam(e.target.value)}
              placeholder="Busca por Nome"
              onKeyDown={(e) => handleSearch(e.keyCode)}
            />}
          {selectedFilter === "parceiros" &&
            <Dropdown
              value={filterParam}
              options={listaParceiros}
              onChange={(e) => setFilterParam(e.target.value)}
              placeholder="Busca por parceiro"
              onKeyDown={(e) => handleSearch(e.keyCode)}
            />}
          {/* {selectedFilter === "status" && <Dropdown
                  value={filterParam}
                  options={statusOptions}
                  onChange={e =>{setFilterParam(e.value)}}
                  />} */}

          <Button
            icon={<FaSearch className="text-xl" />}
            onClick={() => handleSearch(13)}
            pt={{
              root: `hover:dark:bg-green-500 hover:bg-green-600 
              dark:bg-green-400 bg-green-500 p-3
              flex justify-center items-center
              h-[3rem] w-[3rem]
              text-white dark:text-black transition duration-300`,
              label: "absolute",
            }}
          />
          <Button
            icon={<FaTimes className="text-2xl" />}
            pt={{
              root: `hover:dark:bg-red-500 hover:bg-red-600 
              dark:bg-red-400 bg-red-500 p-3 rounded-r-md
              flex justify-center items-center
              h-[3rem] w-[3rem]
              text-white dark:text-black transition duration-300`,
              label: "absolute",
            }}
            onClick={() => {
              setFilterParam("");
              setReload((prevReload) => !prevReload);
              setSearchState(false);
            }}
          />
        </div>
      </div>
    </div>
  );

  const ScreenCheck = () => {
    if (window.screen.width <= 480) {
      setMobile(false);
    } else {
      setMobile(true);
    }
  };

  const sentDateTemplateValidate = (e) => {
    if (e !== "") {
      const formatedDate = format(addHours(new Date(e), 3), "dd/MM/yyyy");
      return formatedDate;
    }

    return "-";
  };

  const documentTemplate = (e) => {
    if (e.usuario_documento) {
      return formatDocument(e.usuario_documento);
    } else {
      return "-";
    }
  };

  const statusBodyTemplate = (e) => {
    let type = "-";
    if (e.cobranca_tipo_pagamento === "Em aberto") {
      type = "bg-sky-200 text-sky-600";
      //   value = "EM ABERTO";
    }
    if (e.cobranca_tipo_pagamento === "Em Aberto") {
      type = "bg-sky-200 text-sky-600";
      // value = "EM ABERTO";
    }
    if (e.cobranca_tipo_pagamento === "Pago" || e.cobranca_tipo_pagamento === "Pago em Dinheiro" || e.cobranca_tipo_pagamento === "Pago junto ao Cliente" || e.cobranca_tipo_pagamento === "Pago durante o Protesto") {
      type = "bg-emerald-300 text-emerald-800";
      // value = 'BAIXA CLIENTE';
    }
    if (e.cobranca_tipo_pagamento === "Pago (Cliente)" || e.cobranca_tipo_pagamento === "Pago no Cartorio") {
      type = "bg-green-300 text-green-800";
      // value = 'BAIXA CLIENTE';
    }
    if (e.cobranca_tipo_pagamento === "Em Processamento" || e.cobranca_tipo_pagamento === "Em Processamento (Parcial)" || e.cobranca_tipo_pagamento === "Em Análise") {
      type = "bg-orange-300 text-orange-700";
      //   value = 'EM PROCESSAMENTO';
    }
    if (e.cobranca_tipo_pagamento === "Inativado" || e.cobranca_tipo_pagamento === "Acordo Não Pago") {
      type = "bg-slate-300 text-slate-700";
      //   value = 'EM PROCESSAMENTO';
    }
    if (e.cobranca_tipo_pagamento === "Em Protesto" || e.cobranca_tipo_pagamento === "Enviado a Protesto") {
      type = "bg-red-300 text-red-700";
      //   value = 'PAGO';
    }
    return (
      <div className="flex justify-center items-center ">
        <span className={classNames(
          'text-nowrap py-1 px-2 justify-center flex w-auto',
          type
        )}
        >
          <p className="uppercase text-sm font-bold">
            {e.cobranca_tipo_pagamento}
          </p>
        </span>
      </div>
    );
  };

  const actionTemplate = (rowData) => {
    return (
      <Button
        icon={<GiCog className="text-2xl" />}
        pt={{
          root: `hover:dark:bg-green-500 hover:bg-green-600
            dark:bg-green-400 bg-green-500
            h-12 w-12 rounded-full
            flex justify-center items-center
            text-white dark:text-black
            transition duration-300`,
          label: "absolute",
        }}
        onClick={(e) => {
          handleSelectAction(rowData);
          menu.current?.toggle(e);
        }}
      />
    );
  };

  return (
    <AppCard className="w-full !p-1">

      <Menu
        model={[...getActionOptions(rowCurrent), ...getCancelaOptions(rowCurrent)]
           // ###### COISA DO  BAKER #######
            // gestorData.gestor_id ?
            //     usuarioId === 'b27a3b75-8a16-4549-b94d-80d7542d83aa' ?
            //         [...actionOptions, ...downloadOptions, ...cancelaOptions] :
            //         [...actionOptions, ...downloadOptions] :
            //     actionOptions
          }
        pt={MenuPague}
        popup
        ref={menu}
      />

      {showAddPayment && <AddPayment rowInfo={rowCurrent} close={() => setShowAddPayment(false)} reload={() => setReload((prevReload) => !prevReload)} toast={toastController} />}
      {showCancelNegotiation && <CancelNegotiation rowInfo={rowCurrent} close={() => setShowCancelNegotiation(false)} reload={() => setReload((prevReload) => !prevReload)} toast={toastController} />}
      {showDetail && <NegotiationDetail rowInfo={rowCurrent} close={() => setShowDetail(false)} toast={toastController} />}

      {showProtestoInfo && <ProtestInfo rowInfo={rowCurrent} close={() => setShowProtestoInfo(false)} toast={toastController} />}

      {showSimulation && <Simulation rowInfo={rowCurrent} close={() => setShowSimulation(false)} toast={toastController} />}
      {showPersonalInfo && <PersonalInfo rowInfo={rowCurrent} close={() => setShowPersonalInfo(false)} toast={toastController} />}
      {showPersonalCobranca && <PersonalCobranca rowInfo={rowCurrent} close={() => setShowPersonalCobranca(false)} reload={() => setReload((prevReload) => !prevReload)} toast={toastController} />}
      {showInativaCobranca && <InaCobranca rowInfo={rowCurrent} close={() => setShowInativaCobranca(false)} reload={() => setReload((prevReload) => !prevReload)} toast={toastController} />}
      {showCommunicationInfo && <CommunicationInfo rowInfo={rowCurrent} close={() => setShowCommunicationInfo(false)} />}
      {showListaRelatorio && <ExportarCobrancas close={() => setShowListaRelatorio(false)} tipo={null} toast={toastController} />}

      <DataTable
        value={negotiationData}
        paginator
        rows={rows}
        rowsPerPageOptions={rowsPerPageOptions}
        totalRecords={totalNegotiation}
        dataKey="cobranca_id"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
        first={first}
        scrollable={mobile}
        lazy
        pt={LargeTablePague}
        onPage={onPage}
        breakpoint="480px"
        emptyMessage="Nenhuma negociação encontrada. "
        loading={loading}
        header={negotiationTableHeader}
      >
        <Column header="Ações" body={(rowData) => actionTemplate(rowData)}></Column>
        <Column header="Status" body={statusBodyTemplate}></Column>
        <Column field="usuario_nome" header="Nome"></Column>
        <Column field="usuario_documento" header="Documento" body={documentTemplate}></Column>
        <Column field="cobranca_numero_cliente_credor" header="Código Cliente"></Column>
        <Column field="cobranca_descricao" header="Descrição"></Column>
        <Column field="cobranca_create" header="Data" body={(rowData) => sentDateTemplateValidate(rowData.cobranca_create)}></Column>
        <Column field="data_vencimento_primeiro_boleto" header="Data de Vencimento" body={(rowData) => sentDateTemplateValidate(rowData.data_vencimento_primeiro_boleto)}></Column>
        <Column field="cobranca_valor" header="Valor Original" body={(rowData) => formatCurrency(rowData.cobranca_valor)}></Column>
        <Column field="valor_corrigido" header="Valor Corrigido" body={(rowData) => formatCurrency(rowData.valor_corrigido)}></Column>
        <Column field="valor_pagamento" header="Valor Pagamento" body={(rowData) => formatCurrency(rowData.valor_pagamento)}></Column>
      </DataTable>
    </AppCard>
  );
};
